import React from 'react'
import { convertFromCentsToDollars } from 'components/FormatPrice/helpers'
import { LocaleCurrency } from 'components/FormatPrice'
import ArtworkInfo from './Artwork'
import ViewMore from './ViewMore'
import OriginalStatus from './Status'
import ArtistInfo from './Artist'
import { getArtworkProps, getArtistProps, getViewMoreProps } from './helpers'
import { Item } from './styles'

import classNames from 'classnames'

const Component = (
  props: Record<string, any>
): React.ReactElement<React.ComponentProps<any>, any> => {
  const {
    shouldOpenNewDesktopPdpTab,
    handleViewProduct,
    hasLimitedEditions,
    hasOpenEditions,
    minPrintPrice,
    originalStatus,
    listPrice,
  } = props
  const artworkProps = getArtworkProps(props)
  const artistProps = getArtistProps(props)
  const viewMoreProps = getViewMoreProps(props)
  const shouldShowPrice = !['unavail', 'reserved'].includes(originalStatus)
  return (
    <Item data-type='original'>
      <div data-style='row' data-type='info'>
        <ArtworkInfo
          handleViewProduct={handleViewProduct}
          {...artworkProps}
          shouldOpenNewDesktopPdpTab={shouldOpenNewDesktopPdpTab}
        />

        <OriginalStatus originalStatus={originalStatus} />
      </div>

      <div data-style='row' data-type='info'>
        <ArtistInfo {...artistProps} />

        <div data-style='column' data-type='prices'>
          {shouldShowPrice && (
            <div data-type='main'>
              <h6 className={classNames('defaultTypographyH6', 'defaultTextTruncate')}>
                <LocaleCurrency price={convertFromCentsToDollars(listPrice)} />
              </h6>
            </div>
          )}

          {hasOpenEditions && (
            <p className='defaultTypographyXSmall' data-type='sub'>
              Prints from <LocaleCurrency price={convertFromCentsToDollars(minPrintPrice)} />
            </p>
          )}

          {hasLimitedEditions && (
            <p className='defaultTypographyXSmall' data-type='sub'>
              Limited Editions from&nbsp;
              <LocaleCurrency price={convertFromCentsToDollars(minPrintPrice)} />
            </p>
          )}
          <ViewMore {...viewMoreProps} />
        </div>
      </div>
    </Item>
  )
}

export default Component
